import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { IrisTokenParserService } from '@sondermind/iris/shared';

const sizeMap: Record<string, number> = {
  xs: 24,
  sm: 40,
  md: 60,
  lg: 90,
  xl: 120,
};
const fontSizeMap: Record<string, string> = {
  xs: '0.75rem',
  sm: '1.15rem',
  md: '1.25rem',
  lg: '1.5rem',
  xl: '1.75rem',
};
@Component({
  selector: 'iris-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class IrisSpinnerComponent {
  readonly text = input<string>('');
  readonly size = input<'xs' | 'sm' | 'md' | 'lg' | 'xl'>('md');
  readonly colorToken = input<string>('$color-dec-turquoise-100');
  readonly removeTopMargin = input<boolean>(false);

  readonly spinnerWidth = computed(() => `${sizeMap[this.size() ?? 'sm']}px`);
  readonly spinnerFontSize = computed(() => fontSizeMap[this.size() ?? 'sm']);
  readonly spinnerColor = computed(() => this.tokenService.getColorFromToken(this.colorToken()));
  readonly spinnerMarginTop = computed(() => (this.removeTopMargin() ? '0' : undefined));

  constructor(
    private tokenService: IrisTokenParserService
  ) {}
}
